import React from "react";
import { Icon, Label, Select } from "@telia/teddy";
import _isEmpty from "lodash/isEmpty";
import format from "date-fns/format";
import "./TimePicker.less";

interface Props {
    selectedDate: Date;
    setSelectedDate: (date: Date) => void;
    listOfHours: Date[];
    id?: string;
}

const TimePicker = ({ selectedDate, setSelectedDate, listOfHours, id = "time-picker-select" }: Props) => {
    return (
        <>
            <Label htmlFor={id} className="time-picker__trigger-label">
                Tid
            </Label>
            <Select
                name={id}
                onValueChange={(val) => {
                    const [hours, minutes] = val.split(":").map(Number);
                    const updated = new Date(selectedDate);
                    updated.setHours(hours, minutes, 0, 0);
                    setSelectedDate(updated);
                    return val;
                }}
                options={listOfHours.map((d) => format(d, "HH:mm"))}
                placeholder="Choose..."
                validationState="valid"
                disabled={_isEmpty(listOfHours)}
                value={format(selectedDate, "HH:mm")}
                maxHeight={300}
                className="time-picker__select"
            >
                <Select.Trigger id={id} className="time-picker__trigger" validationState="valid" data-di-unmask-field>
                    <div className="time-picker__trigger-content">
                        <Icon
                            name="time"
                            size="md"
                            aria-hidden="true"
                            focusable="false"
                            className="time-picker__trigger-icon"
                        />
                        <Select.Value placeholder="Velge..." />
                    </div>
                </Select.Trigger>
                <Select.Portal>
                    <Select.Content>
                        <Select.Viewport>
                            <Select.Group options={listOfHours.map((d) => format(d, "HH:mm"))} />
                        </Select.Viewport>
                    </Select.Content>
                </Select.Portal>
            </Select>
        </>
    );
};

export default TimePicker;
